import { registerSW } from 'virtual:pwa-register';
import { isNative } from '../native/platform.js';
import { showNotice, hideNotice } from './notice.js';

/**
 * Service worker registration.
 *
 * Registration is `prompt` rather than `autoUpdate` on purpose: reloading the
 * page mid-workout would drop the set the user is entering. The new version is
 * offered instead, and applied when they say so — or automatically once no
 * workout is in progress.
 *
 * Skipped entirely on native, where Capacitor serves the bundle from the app
 * package and a service worker would only add a second, staler cache layer.
 */
export function installServiceWorker() {
  if (isNative) return;
  if (!('serviceWorker' in navigator)) return;

  const updateSW = registerSW({
    onNeedRefresh() {
      // Applying an update discards whatever is in the DOM, so an in-progress
      // workout means waiting for the user rather than reloading under them.
      const workoutInProgress = Boolean(globalThis.AppState?.activeWorkout);

      showNotice({
        message: workoutInProgress
          ? 'Update ready — finish your workout to install it.'
          : 'A new version of IronPact is available.',
        actionLabel: workoutInProgress ? undefined : 'Reload',
        onAction: workoutInProgress ? undefined : () => updateSW(true),
      });
    },
    onOfflineReady() {
      showNotice({ message: 'IronPact is ready to use offline.' });
      setTimeout(hideNotice, 4000);
    },
    onRegisterError(err) {
      console.warn('[ironpact] service worker registration failed', err);
    },
  });
}
